import {Selectors} from './selectors'

export default async () => {
  const container = document.querySelector<HTMLElement>(Selectors.gallery)
  if (!container) return
  const {createGallery} = await import('./createGallery')
  await createGallery(container)
}
